module.exports = __webpack_public_path__ + "img/logo_rund.d00c8de.svg";